<template>
  <span>
    <font-awesome-layers
      v-if="signal === signals.UNAVAILABLE"
      style="vertical-align: -0.125em;"
      class="fa-md mr-2"
    >
      <font-awesome-icon
        :icon="['fad','signal-alt']"
        :style="{ color: '#cecece' }"
      />
      <font-awesome-icon
        :icon="['fas','question-circle']"
        :style="{ color: '#535353' }"
        transform="shrink-7 down-9 right-12"
      />
    </font-awesome-layers>
    <v-icon
      :class="['pb-1']"
      :color="signalDisplay.color"
      :style="{'--fa-secondary-color': '#E1EBEE'}"
      size="18"
    >
      {{ signalDisplay.icon }}
    </v-icon>
    <span class="ml-1">{{ signalDisplay.text }}</span>
  </span>
</template>
<script>
  import { getSignalStrength, getSignalDisplay, signals } from '@/helpers/sensor-connectivity.js'
  export default {
    name: 'SignalStrength',
    props: {
      zone: Object,
    },
    computed: {
      signals () {
        return signals
      },
      signal () {
        return getSignalStrength({ style: this.zone.style, RSSI: this.zone.RSSI })
      },
      signalDisplay () {
        return getSignalDisplay({ signal: this.signal })
      },
    },
  }
</script>
